export default {"src":"/_next/static/image/public/images/flags/flag_57.1697ea6ce91ce0a27237ef3bf0236303.svg","height":16,"width":25};